import { render } from "./ChannelIcon.vue?vue&type=template&id=887be328&scoped=true&lang=pug"
import script from "./ChannelIcon.vue?vue&type=script&lang=js"
export * from "./ChannelIcon.vue?vue&type=script&lang=js"

import "./ChannelIcon.vue?vue&type=style&index=0&id=887be328&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-887be328"]])

export default __exports__